module.exports = __webpack_public_path__ + "img/product_class_header.0bcdc1a2.jpg";